export function getConfigValue(config, env) {
    const value = config[env] || config.default;
    if (!value) {
        throw new Error(`No config value found in ${config} for ${env}`);
    }
    return value;
}
